import { Product } from "../types/product";
import { get, post } from "./fetch.core";

async function listRecycleProducts(search?: string) {
  return (await get<Product[]>(`/admin/recycle/listProducts?search=${search ?? ""}`)).data;
}

async function countRecycles(data: { productIds?: string[]; date: any }) {
  return (await post<{ soldCount: number; receivedCount: number }>("/admin/recycle/count", data)).data;
}

const recycleCore = {
  listRecycleProducts,
  countRecycles,
};

export default recycleCore;
